import { Expose } from "class-transformer";
import { CmsPaginationDto } from "../cms-pagination/cms-pagination.dto";
import { ICmsResponseMetadataDto } from "./cms-response-metadata.dto.interface";

export class CmsResponseMetadataDto implements ICmsResponseMetadataDto {
  @Expose()
  pagination!: CmsPaginationDto;
}
